import { render, staticRenderFns } from "./MyImg.vue?vue&type=template&id=55d1f9ee&scoped=true"
import script from "./MyImg.vue?vue&type=script&lang=js"
export * from "./MyImg.vue?vue&type=script&lang=js"
import style0 from "./MyImg.vue?vue&type=style&index=0&id=55d1f9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1f9ee",
  null
  
)

export default component.exports